import React from 'react';
import PropTypes from 'prop-types';

const TableButtonCell = ({ children }) => {
  return (
    <td className="align-middle text-center" style={{ width: '1px' }}>
      {children}
    </td>
  );
};
TableButtonCell.propTypes = {
  children: PropTypes.node.isRequired
};

export default TableButtonCell;
